module.exports = __webpack_public_path__ + "static/media/acgh.ad8f1885.png";